import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getMoneda = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api     
    .get(excludeChars ? `${url.stage.currencies}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.currencies}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})    
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newMoneda = async data =>
  api
    .post(url.stage.currencies, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editMoneda = async (stateId, data) =>
  api
    .put(`${url.stage.currencies}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeMoneda = async stateId =>
  api
    .remove(`${url.stage.currencies}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getMoneda,
  newMoneda,
  editMoneda,
  removeMoneda,
}
